import { render, staticRenderFns } from "./SecondLevelDisclaimer.vue?vue&type=template&id=2b705258&scoped=true"
import script from "./SecondLevelDisclaimer.vue?vue&type=script&lang=js"
export * from "./SecondLevelDisclaimer.vue?vue&type=script&lang=js"
import style0 from "./SecondLevelDisclaimer.vue?vue&type=style&index=0&id=2b705258&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b705258",
  null
  
)

export default component.exports